import { render, staticRenderFns } from "./SwiperSlider.vue?vue&type=template&id=840aa0e0&scoped=true"
import script from "./SwiperSlider.vue?vue&type=script&lang=js"
export * from "./SwiperSlider.vue?vue&type=script&lang=js"
import style0 from "./SwiperSlider.vue?vue&type=style&index=0&id=840aa0e0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840aa0e0",
  null
  
)

export default component.exports